module.exports = __webpack_public_path__ + "img/l200_safe.216cc1cc.jpg";